function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "02.-E---apm\\u0101c\\u012Bba---S\\u0101kums-(-piekt\\u0101-nodarb\\u012Bba)",
  transform: "translate(-812.000000, -209.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(294.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sessions",
  transform: "translate(24.000000, 129.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "9---12",
  transform: "translate(472.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(22.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5,0 C7.76142375,0 10,2.23857625 10,5 C10,7.76142375 7.76142375,10 5,10 C2.23857625,10 0,7.76142375 0,5 C0,2.23857625 2.23857625,0 5,0 Z",
  id: "Path",
  fill: "#079DC1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "4.85351562 5.41210938 4.43164062 5.875 4.43164062 7 3.40332031 7 3.40332031 2.734375 4.43164062 2.734375 4.43164062 4.61523438 4.7890625 4.07324219 5.70898438 2.734375 6.98046875 2.734375 5.5390625 4.62109375 6.98046875 7 5.76171875 7"
})))))));

function SvgIcSmallXsKlatiene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8B10F240-4612-4BBB-8790-5AF81A3DD021") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmallXsKlatiene);
export default __webpack_public_path__ + "static/media/ic-small-xs-klatiene.dea3b477.svg";
export { ForwardRef as ReactComponent };